import { render, staticRenderFns } from "./bonos.vue?vue&type=template&id=10001293&"
import script from "./bonos.vue?vue&type=script&lang=js&"
export * from "./bonos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports